"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientFacilityStatus = exports.statusNames = void 0;
var enums_1 = require("../utils/enums");
exports.statusNames = {
    ACTIVE: "Active",
    ACCOUNT_ACTIVE: "Account Active",
    FOLLOW_UP: "Follow Up",
    SETUP_INCOMPLETE: "Setup Incomplete",
    READY_FOR_ACTIVATION: "Ready for Activation",
    STRIPE_SETUP_INCOMPLETE: "Stripe Setup Incomplete",
    CLOSED: "Closed",
    ACCOUNT_CLOSED_DEACTIVATED: "Account Closed / Deactivated",
    ALERT: "Alert",
    STRIPE_ACTION_NEEDED: "Stripe Action Needed",
};
exports.clientFacilityStatus = [
    {
        status: exports.statusNames.ACTIVE,
        type: "primary-status",
        color: enums_1.StatusColors.success,
    },
    {
        status: exports.statusNames.ACCOUNT_ACTIVE,
        type: "sub-status",
        color: enums_1.StatusColors.success,
    },
    {
        status: exports.statusNames.FOLLOW_UP,
        type: "primary-status",
        color: enums_1.StatusColors.warning,
    },
    {
        status: exports.statusNames.SETUP_INCOMPLETE,
        type: "sub-status",
        color: enums_1.StatusColors.warning,
    },
    {
        status: exports.statusNames.READY_FOR_ACTIVATION,
        type: "sub-status",
        color: enums_1.StatusColors.warning,
    },
    {
        status: exports.statusNames.STRIPE_SETUP_INCOMPLETE,
        type: "sub-status",
        color: enums_1.StatusColors.warning,
    },
    {
        status: exports.statusNames.CLOSED,
        type: "primary-status",
        color: enums_1.StatusColors.error,
    },
    {
        status: exports.statusNames.ACCOUNT_CLOSED_DEACTIVATED,
        type: "sub-status",
        color: enums_1.StatusColors.error,
    },
    {
        status: exports.statusNames.ALERT,
        type: "primary-status",
        color: enums_1.StatusColors.error,
    },
    {
        status: exports.statusNames.STRIPE_ACTION_NEEDED,
        type: "sub-status",
        color: enums_1.StatusColors.error,
    },
];
